import React, { useEffect, useRef, useState } from "react";
import { Card, Table, Input , notification} from "antd";
import { Row, Col } from "react-bootstrap";
import { SearchOutlined } from "@ant-design/icons";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { LuMailCheck } from "react-icons/lu";
import { MdMyLocation } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import { Button } from "@mui/material";
import axios from "axios";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import { TiLocationArrowOutline } from "react-icons/ti";
import { useNavigate ,Link} from "react-router-dom";



const UtmMappingForm = () => {
  const [selectedLeadIds, setSelectedLeadIds] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [isLeadData, setLeadData] = useState([]);
  const [isBusinessData, setBusinessData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUniqueIds, setSelectedUniqueIds] = useState([]); // Holds selected uniqueIds

  const navigate = useNavigate();

  const columns = [
    {
      title: "Registered Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => {
        return new Date(createdAt).toISOString().slice(0, 10) || "-";
      },
    },
    {
      title: "UTM Id",
      dataIndex: "leadId",
      key: "leadId",
    },
    {
      title: "Move on Date",
      dataIndex: "leadData",
      key: "movingDate",
      render: (leadData) => leadData?.movingDate || "-",
    },
    {
      title: "Name",
      dataIndex: "leadData",
      key: "leadname",
      render: (leadData) => leadData?.name || "-",
    },
    {
      title: "Phone",
      dataIndex: "leadData",
      key: "phoneNumber",
      render: (leadData) => leadData?.phone || "-",
    },
  ];

  const handleExpand = (expanded, record) => {
    setExpandedRowKeys(expanded ? [record.key] : []); // Ensure only one row expands
  };

  // Leads API
  const getUTMleadsData = async () => {
    const accessToken = localStorage.getItem("accessToken");
    axios
      .get("https://apicanada.blaccdot.com/lead/utmleads/3", {
        headers: { Authorization: `${accessToken}` },
      })
      .then((res) => {
        const data = res?.data?.data?.leads?.map((item, index) => ({
          ...item,
          key: item.leadId,
          uniqueId: item._id,
        }));

        setLeadData(data);
      });
  };

  // Leads Search API
  const getLeadsSearchData = async (value) => {
    const accessToken = localStorage.getItem("accessToken");

    if (!value) {
      // If the search value is empty, skip the request or handle it accordingly
      getUTMleadsData(); // Clear the current data, if needed
      return;
    }

    try {
      await axios
        .get(
          // `https://apicanada.blaccdot.com/lead/utmleadssearch?searchValue=${value}`,
          `https://apicanada.blaccdot.com/lead/utmleadssearch?searchValue=${value}&categoryID=2`,
          {
            headers: { Authorization: `${accessToken}` },
          }
        )
        .then((res) => {
          const data = res?.data?.data?.leads?.map((item, index) => ({
            ...item,
            key: item.leadId,
            uniqueId: item._id,
          }));

          setLeadData(data);
        });
    } catch (error) {
      console.error("Error fetching search data:", error);
    }
  };

  // Business API
  const getBusinessData = async () => {
    const accessToken = localStorage.getItem("accessToken");
    axios
      .get("https://apicanada.blaccdot.com/user/subscription-business/2", {
        headers: { Authorization: `${accessToken}` },
      })
      .then((res) => {
        const data = res?.data?.data?.businesses;
        setBusinessData(data);
      });
  };
  //success modal
  const successMessage = () => {
    notification.success({
      message: 'Success',
      description: 'UTM Mapped successfully!',
    });
    // navigate("/admin/utm-mapping"); 
  };

  // Submit API
  const submit = async () => {
    const selectedIds = {
      userIds: selectedUserIds,
      leadIds: selectedLeadIds,
    };
    const accessToken = localStorage.getItem("accessToken");
    axios
      .post(
        "https://apicanada.blaccdot.com/lead/distributedutmlead",
        selectedIds,
        { headers: { Authorization: `${accessToken}` } }
      )
      .then((response) => {
        successMessage();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  //Leads Checkbox Selection
  const rowSelection = {
    onChange: (newSelectedRowKeys) => {

      const addedUniqueIds = newSelectedRowKeys
        .map(
          (leadId) =>
            isLeadData.find((item) => item.leadId === leadId)?.uniqueId
        )
        .filter(Boolean);

      const removedUniqueIds = selectedUniqueIds.filter(
        (id) => !addedUniqueIds.includes(id)
      );

      setSelectedUniqueIds((prevSelected) => [
        ...prevSelected.filter((id) => !removedUniqueIds.includes(id)),
        ...addedUniqueIds,
      ]);

      setSelectedLeadIds(newSelectedRowKeys);
    },
  };

  //Business Checkbox Selection
  const handleBusinessCheckboxChange = (userId) => {
    setSelectedUserIds((prevSelected) => {
      if (prevSelected.includes(userId)) {
        // If the userId is already in the selected list, remove it
        return prevSelected.filter((id) => id !== userId);
      } else {
        // Otherwise, add the userId to the selected list
        return [...prevSelected, userId];
      }
    });
  };

  //Set time out for 1sec to leads data search
  const useDebounce = (func, delay) => {
    const timeoutRef = useRef(null);

    const debouncedFunction = (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current); // Clear the previous timeout
      }
      timeoutRef.current = setTimeout(() => {
        func(...args); // Call the original function after delay
      }, delay);
    };

    return debouncedFunction;
  };

  const debouncedSearch = useDebounce(getLeadsSearchData, 1000);

  //Business Search method
  const handleBusinessSearch = (value) => {
    setSearchTerm(value);
  };

  // Set the business data for search
  const filteredBusinessData = isBusinessData.filter((item) =>
    String(item?.companyName || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item?.location || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item?.email || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item?.mobileNo || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item?.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item?.country || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item?.state || "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  
  useEffect(() => {
    getUTMleadsData();
    getBusinessData();
  }, []);

  return (
    <div>
      <Row>
        <Col md={6}>
         <Link to='/admin/utm-mapping'>
               <IoChevronBackCircleOutline style={{color:'red', fontSize:'30px', cursor:'pointer', marginTop:'20px'}}/></Link>
        </Col>
        <Col md={6} className="text-end">
           <Button variant="contained" className="w-25 my-3" onClick={() => submit()}>
            Submit
          </Button>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <Card style={{ width: "100%" }} title="Movers UTM Leads">
            <>
              <Input
                placeholder="Search location, utm id..."
                prefix={<SearchOutlined style={{ color: "#888" }} />}
                style={{ borderRadius: "5px", padding: "8px 12px" }}
                onChange={(e) => debouncedSearch(e.target.value)} />
              <hr style={{ color: "#5F5F5F" }} />
            </>
            <Table
              dataSource={isLeadData}
              columns={columns}
              scroll={{ x: "max-content" }}
              rowSelection={rowSelection}
              expandable={{
                expandedRowRender: (item) => (
                  <>
                    <Row>
                      <Col md={6}>
                        <div style={{ display: "grid" }}>
                          <span className="mb-2">
                            Email ID : {item?.leadData?.email}
                          </span>
                          <span className="mb-2">
                            Property Size : {item?.leadData?.propertySize}
                          </span>
                          <span className="mb-2">
                            Property Type: {item?.leadData?.propertyType}
                          </span>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ display: "grid" }}>
                          <span className="mb-2">
                            Moving from: {item?.leadData?.movingFrom}
                          </span>
                          <span className="mb-2">
                            Moving to : {item?.leadData?.movingTo}
                          </span>
                          <span className="mb-2">
                            Available time to call: {item?.leadData?.timeToCall}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </>
                ),
                rowExpandable: (record) => record.name !== "Not Expandable",
                expandedRowKeys: expandedRowKeys,
                onExpand: handleExpand,
              }}
            />
          </Card>
        </Col>

        <Col md={4}>
          <Card title="Movers Business panel" style={{ width: '100%' }}>
            <>
              <Input
                placeholder="Search location,bussiness..."
                prefix={<SearchOutlined style={{ color: "#888" }} />}
                style={{ borderRadius: "5px", padding: "8px 12px" }}
                value={searchTerm} // Bind search term to input
                onChange={(e) => handleBusinessSearch(e.target.value)} // Handle search input change
              />
              <hr style={{ color: "#5F5F5F" }} />
            </>
            {filteredBusinessData?.map((item, index) => (
              <div
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  marginTop: "10px",
                }}
                key={item.userId}
              >
                <div className="carder2">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            handleBusinessCheckboxChange(item.userId)
                          }
                          checked={selectedUserIds.includes(item.userId)} // Reflect selected state
                        />
                      }
                    />
                  </FormGroup>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "left",
                    }} >
                    <span style={{ fontSize: "14px" }}>
                      {item?.companyName}
                    </span>
                    <span style={{ fontSize: "12px", color: "#888" }}>
                      <IoLocationOutline style={{ marginRight: "5px" }} />
                      {item?.location}
                    </span>
                    <span style={{ fontSize: "12px", color: "#888" }}>
                      <LuMailCheck style={{ marginRight: "5px" }} />{" "}
                      {item?.email}
                    </span>
                    <span style={{ fontSize: "12px", color: "#888" }}>
                      <TiLocationArrowOutline style={{ marginRight: "5px" }} />{" "}
                      {item?.country}
                    </span>
                    <span style={{ fontSize: "12px", color: "#888", paddingBottom:'20px' }}>
                      <MdMyLocation style={{ marginRight: "5px" }} />{" "}
                      Preferred location
                      {/* {item?.stateNames} */}

                      {item?.stateNames?.length > 0 ? (
                        <ul>
                          {item.stateNames.map((state, index) => (
                            <li key={index}>{state}</li>
                          ))}
                        </ul>
                      ) : (
                        <p>No states available</p>
                      )}

                    </span>
                  </div>
                </div>
              </div>
            ))}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default UtmMappingForm;


// import React,{useState} from 'react'
// import Title from "antd/es/typography/Title";
// import { Card, Table, Modal,Typography,DatePicker,Input } from 'antd';
// import {Row,Col} from 'react-bootstrap';
// import { SearchOutlined } from '@ant-design/icons';
// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import { LuMailCheck } from "react-icons/lu";
// import { IoLocationOutline } from "react-icons/io5";
// import Select from 'react-select';
// import {Button} from '@mui/material'


// const UtmMappingForm = () => {

//     const [selectedRowKeys, setSelectedRowKeys] = useState([]);



//       const dataSource = [
//         {
//           key: '1',
//           registerData:'2025-01-13',
//           UTMID: 23,
//           movingData: '21-13-2025	',
//           leadname:'Mohammed Fareestha',
//           phoneNumber: 9873747728,
//         },
//         {
//           key: '2',
//           registerData:'01-13-2025',
//           UTMID: 24,
//           movingData: '21-13-2025',
//           leadname:'Udhaya suriya',
//           phoneNumber: 9873747728,
//         },
//       ];
      
//       const columns = [
//         {
//           title: 'Registered Date',
//           dataIndex: 'registerData',
//           key: 'registerData',
//         },
//         {
//           title: 'UTM Id',
//           dataIndex: 'UTMID',
//           key: 'UTMID',
//         },
//         {
//           title: 'Move on Date',
//           dataIndex: 'movingData',
//           key: 'movingData',
//         },
//         {
//           title: 'Name',
//           dataIndex: 'leadname',
//           key: 'leadname',
//         },
//         {
//           title: 'Phone',
//           dataIndex: 'phoneNumber',
//           key: 'phoneNumber',
//         },
//       ];

//       const rowSelection = {
//         selectedRowKeys, 
//         onChange: (newSelectedRowKeys) => {
//           setSelectedRowKeys(newSelectedRowKeys); 
//           console.log('Selected Row Keys: ', newSelectedRowKeys);
//         },
//       };



//   return (
//     <div>
//        <Title level={2}>Map Leads</Title>
//       <Row>
//         <Col md={8}>
//           <Card style={{ width: '100%' }}  title="UTM Leads">
//             <>
//              <Input placeholder="Search here..." prefix={<SearchOutlined style={{ color: '#888' }} />}
//               style={{borderRadius: '5px', padding: '8px 12px'}}/><hr style={{color:'#5F5F5F'}} />
//             </>
//             <hr/>
//             <Table dataSource={dataSource} columns={columns}  scroll={{ x: 'max-content' }}
//               rowSelection={rowSelection} 
//                  expandable={{
//                         expandedRowRender: (record) => (
//                             <>
//                            <Row>
//                             <Col md={6}>
//                               <div style={{display:'grid'}}>
//                               <span className="mb-2">Email ID : www.euctoc.com</span>
//                               <span className="mb-2">Property Size : STUDIO</span>
//                               <span className="mb-2">Property Type: HOUSE</span>
//                             </div>
//                             </Col>
//                             <Col md={6}>
//                               <div style={{display:'grid'}}>
//                               <span className="mb-2">Moving from: Oxfordshire, UK</span>
//                               <span className="mb-2">Moving to : Newcastle upon Tyne, UK</span>
//                               <span className="mb-2">Available time to call: 12:30 PM</span>
//                             </div>
//                             </Col>
//                           </Row>
                              
//                             </>
//                         ), 
//                         rowExpandable: (record) => record.name !== 'Not Expandable',
//                       }}/>
//            </Card>
//         </Col>


//         <Col md={4}>
//         <Card title="Business panal" style={{ width: 300, }}>
//           <>
//              <Input placeholder="Search here..." prefix={<SearchOutlined style={{ color: '#888' }} />}
//               style={{borderRadius: '5px', padding: '8px 12px'}}/><hr style={{color:'#5F5F5F'}} />
//           </>
//           <div style={{border: "1px solid #ddd", borderRadius:'6px',marginTop:'10px'}}>
//               <div className='carder2'>
//                <FormGroup>
//                  <FormControlLabel control={<Checkbox />} />
//                </FormGroup>
//                         <div style={{ display: "flex",flexDirection: "column", textAlign: "left" }}>
//                           <span style={{fontSize: "14px" }}>Persistent Systems Ltd</span>
//                           <span style={{ fontSize: "12px", color: "#888" }}><IoLocationOutline style={{ marginRight: '5px'}}/> New york, USA</span>
//                           <span style={{ fontSize: "12px", color: "#888" }}><LuMailCheck style={{ marginRight: '5px'}}/> euctoverse@eucto.com</span>
//                         </div>
//                   </div>
//             </div>
//           <div style={{border: "1px solid #ddd", borderRadius:'6px', marginTop:'10px'}}>
//               <div className='carder2'>
//                <FormGroup>
//                  <FormControlLabel control={<Checkbox />} />
//                </FormGroup>
//                         <div style={{ display: "flex",flexDirection: "column", textAlign: "left" }}>
//                           <span style={{fontSize: "14px" }}>Persistent Systems Ltd</span>
//                           <span style={{ fontSize: "12px", color: "#888" }}><IoLocationOutline style={{ marginRight: '5px'}}/> New york, USA</span>
//                           <span style={{ fontSize: "12px", color: "#888" }}><LuMailCheck style={{ marginRight: '5px'}}/> euctoverse@eucto.com</span>
//                         </div>
//                   </div>
//             </div>
//           </Card>
//         </Col>
//       </Row>  
//     </div>
//   )
// }

// export default UtmMappingForm





